<template>
  <div class="pa-10">
    <div style="height: 88vh; position: relative" class="overflow-y-auto">
      <v-container class="d-flex">
        <div style="width: 50%">
          <div class="mt-4 d-flex justify-end mx-5">
            <div
              class="border border-1 rounded-lg pa-4 text-center"
              style="width: 80%"
            >
              <div style="width: 100px; margin: 0 auto">
                <img
                  style="width: 100%; border-radius: 100%"
                  src="../../assets//img/img_avatar.png"
                  alt=""
                />
              </div>
              <div class="text-h4">Name</div>
              <div class="text-caption">adasdasdadadsa</div>
              <div class="text-caption">sadadadasd</div>
            </div>
          </div>
          <div class="mt-4 d-flex justify-end mx-5">
            <div class="border border-1 rounded-lg pa-4" style="width: 80%">
              <div class="text-h6">Contact Information</div>
              <div class="text-caption text-grey mt-2">
                <v-icon>mdi-email-outline</v-icon> &nbsp;&nbsp;email@email.com
              </div>
              <div class="text-caption text-grey mt-2">
                <v-icon>mdi-phone-outline</v-icon> &nbsp;&nbsp;09123123123
              </div>
              <div class="text-caption text-grey mt-2">
                <v-icon>mdi-map-marker-account</v-icon> &nbsp;&nbsp;asdasd ad
                asdasd asda d
              </div>
            </div>
          </div>
        </div>
        <div style="width: 50%">
          <div class="mt-4">
            <div class="border border-1 rounded-lg pa-4" style="width: 80%">
              <div class="d-flex justify-space-between">
                <div class="text-subtitle-1 font-weight-bold">
                  Professional Summary
                </div>
                <div class="text-caption" style="color: #00a63e">Edit</div>
              </div>
              <div class="text-caption text-grey text-justify">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo
                natus iure nobis cupiditate. Quos animi facere dolorem incidunt
                in ipsam iure sapiente consequuntur facilis laudantium, fugiat,
                voluptates fuga alias aut?
              </div>
            </div>
          </div>
          <div class="mt-4">
            <div class="border border-1 rounded-lg pa-4" style="width: 80%">
              <div class="d-flex justify-space-between">
                <div class="text-subtitle-1 font-weight-bold">Skills</div>
                <div class="text-caption" style="color: #00a63e">Add Skill</div>
              </div>
              <div class="">
                <v-chip
                  class="px-1 mx-1 text-caption text-grey"
                  size="20"
                  v-for="i in 20"
                  :key="i"
                  >Skill</v-chip
                >
              </div>
            </div>
          </div>
          <div class="mt-4">
            <div class="border border-1 rounded-lg pa-4" style="width: 80%">
              <div class="d-flex justify-space-between">
                <div class="text-subtitle-1 font-weight-bold">Education</div>
                <div class="text-caption" style="color: #00a63e">Edit</div>
              </div>
              <div class="d-flex align-center">
                <div class="mr-4">
                  <v-icon color="#00a63e">mdi-school-outline</v-icon>
                </div>
                <div class="">
                  <div class="text-caption font-weight-bold">
                    Bachelor of Science in Information Technology
                  </div>
                  <div class="text-caption text-grey">
                    Davao del Norte State College
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-container>
    </div>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>
<script>
// import eventBus from "@/eventBus";
export default {
  name: "ProfilePage",

  data() {
    return {
      updateDetails: false,
      action: null,
      taggingData: null,
      isSelecting: false,
      selectFile: null,
      previewImg: null,
      tagGrade: null,
      tab: null,
      // items: ["Personal Information", "Login Info"],
      items: ["Personal Information"],
      totalYears: null,
      filter: null,
      data: {
        id: null,
        name: null,
        fname: null,
        mname: null,
        lname: null,
        suffix: null,
        sex: null,
        mobile_no: null,
        profile_img: null,
        hired: null,
        education: null,
        status: null,
      },
      oldPass: null,
      password: null,
      confirmPassword: null,
      showOldPass: false,
      show1: false,
      show2: false,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "System Message!",
        message: "",
        top: 10,
      },
      readonly: true,
      credentialReadonly: true,
    };
  },
  mounted() {
    this.initialize();
  },
  beforeUnmount() {},

  methods: {
    initialize() {
      this.axiosCall("/user-details/getPersonalInfo", "GET").then((res) => {
        if (res.data) {
          this.data.id = res.data.id;
          this.data.name = res.data.lname + ", " + res.data.fname;
          this.data.fname = res.data.fname;
          this.data.mname = res.data.mname;
          this.data.lname = res.data.lname;
          this.data.suffix = res.data.suffix;
          this.data.hired = res.data.hired;
          this.data.education = res.data.education;
          this.data.sex = res.data.sex;
          this.data.status = res.data.status;
          this.data.mobile_no = res.data.mobile_no;
          this.data.profile_img = res.data.profile_img
            ? process.env.VUE_APP_SERVER +
              "/user-details/getProfileImg/" +
              res.data.profile_img
            : process.env.VUE_APP_SERVER +
              "/user-details/getProfileImg/img_avatar.png";
        }
      });
    },

    updateCredential() {
      if (this.$refs.loginInfo.validate()) {
        let data = {
          old_password: this.oldPass,
          new_password: this.password,
        };
        this.axiosCall("/auth/changePass", "POST", data).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.password = null;
            this.confirmPassword = null;
            this.credentialReadonly = true;
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.show = true;
          }
        });
      }
    },

    updateProfile() {
      if (this.$refs.personalInfo.validate()) {
        const fd = new FormData();
        this.axiosCall("/user-details/updateUser", "POST", this.data).then(
          (res) => {
            if (res.data.status == 200) {
              if (this.selectFile) {
                fd.append("file", this.selectFile);
                this.axiosCall("/user-details/uploadimage", "POST", fd).then(
                  (resp) => {
                    if (resp.data.status == 200) {
                      this.initialize();
                      this.fadeAwayMessage.message = resp.data.msg;
                      this.fadeAwayMessage.show = true;
                      this.readonly = true;
                      this.$emit("reloadProfile");
                    } else if (resp.data.status == 400) {
                      this.initialize();
                      this.fadeAwayMessage.message = resp.data.msg;
                      this.fadeAwayMessage.show = true;
                      this.readonly = true;
                    }
                  },
                );
              } else {
                this.initialize();
                this.fadeAwayMessage.message = res.data.msg;
                this.fadeAwayMessage.show = true;
                this.readonly = true;
              }
            } else if (res.data.status == 400) {
              this.initialize();
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.show = true;
              this.readonly = true;
            }
          },
        );
      }
    },

    handleFileImport() {
      let fileUpload = document.getElementById("fileUpload");
      if (fileUpload != null) {
        fileUpload.click();
      }
    },
    onFileChanged() {
      const uploadedimg = document.getElementById("fileUpload").files[0];
      this.selectFile = uploadedimg;

      this.previewImg = URL.createObjectURL(uploadedimg);
      this.isSelecting = true;
    },
  },
  created() {
    this.initialize();
    // console.log("created");
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
      // location.reload();
    }
  },
};
</script>
<style scoped>
.profile-row {
  border-radius: 15px !important;
}
.profile-left-panel {
  background-color: #f1f7ff;
}
.profile-right-panel {
  background-color: #ffffff;
}
</style>
